export default class LocalStorageService {
  Get (propName, onlyString) {
    let strItem = localStorage.getItem(propName)
    if (strItem) {
      let obj =  onlyString ? strItem : JSON.parse(strItem)
      return obj
    }
    return null;
  }

  Set (propName, value, onlyString) {
    let obj = onlyString ? value : JSON.stringify(value)
    localStorage.setItem(propName, obj)
  }

  Delete (propName) {
    localStorage.removeItem(propName)
  }
}
